var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"notify"}},[_c('v-btn',{attrs:{"plain":""},on:{"click":function($event){return _vm.setCurrency(_vm.valor)}}},[_c('span',[_vm._v("Dolar: "+_vm._s(_vm._f("currency")(_vm.valor)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }